import SitePhoto from '@/components/Photo'
import { localizeHref } from '@/i18n/href'
import { useI18n } from '@/i18n/I18nProvider'
import { Ctas, HERO_PHOTO, type SectionOf } from './shared'

export default function SplitSection({ section }: { section: SectionOf<'split'> }) {
  const { locale } = useI18n()
  const photoClassName =
    section.photoFit === 'contain'
      ? HERO_PHOTO.replace('aspect-[3/2] ', '').replace('object-cover', 'object-contain')
      : HERO_PHOTO
  const photo = (
    <SitePhoto photo={section.photo} sizes="(min-width: 1024px) 46vw, 92vw" className={photoClassName} />
  )
  return (
    <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
      <div className={section.flip ? 'lg:order-last' : undefined}>
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          {section.heading}
        </h2>
        {section.paragraphs.map((p) => (
          <p key={p.slice(0, 40)} className="mt-6 text-lg leading-relaxed">
            {p}
          </p>
        ))}
        {section.cta && <Ctas items={[section.cta]} />}
      </div>
      {/* `photoHref` makes the picture a second way into the same page as the
          button beside it. `aria-hidden` on the link keeps it out of the tab
          order and off a screen reader: it is the same destination the button
          already announces, and an unlabelled duplicate link is noise. */}
      {section.photoHref ? (
        <a href={localizeHref(section.photoHref, locale)} aria-hidden="true" tabIndex={-1} className="block">
          {photo}
        </a>
      ) : (
        photo
      )}
    </div>
  )
}
